import { render, staticRenderFns } from "./CoverageDetailScienceGraphicsList.vue?vue&type=template&id=eb7df6ac"
import script from "./CoverageDetailScienceGraphicsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageDetailScienceGraphicsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports